module.exports = __webpack_public_path__ + "img/zynthia-howse.daa5c1ab.jpg";